import { useState, useId, useEffect } from 'react';
import { authAPI } from 'services/newPlatformAuth.service';
import AppnextLogo from 'assets/images/Appnext_Logo.png';
import { Loader } from 'components';
import * as S from './UserLogin.styled';

export const PASSWORD_RESET_REQUIRED = 'PASSWORD_RESET_REQUIRED';

const RESEND_COOLDOWN_SECONDS = 60;

export const isPasswordResetRequired = (err) => err?.data?.ErrorCode === PASSWORD_RESET_REQUIRED;

export const PasswordResetRequired = ({ email, message, onBack }) => {
  const formId = useId();
  const [resendSeconds, setResendSeconds] = useState(RESEND_COOLDOWN_SECONDS);
  const [resendMessage, setResendMessage] = useState('');
  const [resendError, setResendError] = useState('');

  const [resendAction, resendResult] = authAPI.useResendForgotPasswordEmailMutation();

  useEffect(() => {
    if (resendSeconds <= 0) return undefined;

    const timer = setInterval(() => {
      setResendSeconds((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);

    return () => clearInterval(timer);
  }, [resendSeconds]);

  const handleResend = async () => {
    if (resendSeconds > 0 || resendResult.isLoading) return;

    setResendMessage('');
    setResendError('');
    try {
      await resendAction({ Email: email }).unwrap();
      setResendMessage('The email was sent again.');
      setResendSeconds(RESEND_COOLDOWN_SECONDS);
    } catch (err) {
      setResendError(err?.data?.Message || 'Failed to resend the email');
    }
  };

  return (
    <>
      {resendResult.isLoading && <Loader.Global delay={100} />}
      <S.StyledForm id={formId}>
        <div style={{ marginBottom: '24px' }}>
          <S.FlexCenter style={{ marginBottom: '16px' }}>
            <S.Label>Reset Password</S.Label>
            <img src={AppnextLogo} alt='Appnext Logo' height={33} />
          </S.FlexCenter>
          <S.SeparatorGradient />
        </div>

        <S.Paragraph style={{ marginBottom: '24px', textAlign: 'center' }}>
          {message || 'For security reasons you must set a new password.'}
          <br />
          Please check your email and follow the link to choose a new password.
        </S.Paragraph>

        <S.Footer style={{ flexDirection: 'column', gap: '12px', marginBottom: '16px' }}>
          <S.Paragraph style={{ textAlign: 'center' }}>
            Didn&apos;t receive the email? Check your spam folder or{' '}
            {resendSeconds > 0 ? (
              <span>resend in {resendSeconds}s</span>
            ) : (
              <S.TextButton type='button' onClick={handleResend} disabled={resendResult.isLoading}>
                Resend the Email
              </S.TextButton>
            )}
          </S.Paragraph>
          {resendMessage && (
            <S.Paragraph style={{ textAlign: 'center' }}>{resendMessage}</S.Paragraph>
          )}
          {resendError && <S.ErrorText>{resendError}</S.ErrorText>}
          <S.TextButton type='button' onClick={onBack}>
            Back to Login
          </S.TextButton>
        </S.Footer>
      </S.StyledForm>
    </>
  );
};
